export default function validateNumber(number) {
  const isNumber = Number.isInteger(Number(number));
  const isCorrectLength =
    number.length === 10 ||
    (number.substr(0, 1) === '1' && number.length === 11);

  return isNumber && isCorrectLength;
}
